/**
 * The redesigned nudge view (nudge-v2) is shown only for targets that have the
 * A/B Testing view enabled (`ab_testing_tool` on the target object).
 */
export function usesNudgeV2(abTestingView: unknown): boolean {
  return abTestingView === true;
}
